/** Classes for the quiet link back to the parent list, shown above a page header. */
export const BACK_LINK_CLASS =
	"inline-flex w-fit items-center gap-1 text-xs text-meta hover:text-foreground [&_svg]:size-3.5"
